import React, { useEffect, useState } from "react"
import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Row,
  Table,
  UncontrolledTooltip,
} from "reactstrap"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import Switch from "components/Shared/Switch"
import {
  deleteModifier,
  enableDisableModifier,
  getAllModifier,
  getModifierDetails,
  updateModifierStatus,
} from "store/actions/modiferAction"
import { showAlert } from "store/reducers/alertReducer"
import DeleteModal from "components/Common/DeleteModal"
import Paginations from "components/Common/Paginations"
import Filters from "components/Common/Filters"
import DataExportDropdown from "components/Shared/DataExportDropdown"
import isPermissionEnabled, {
  getSubPermissions,
} from "common/isPermissionEnabled"
import ItemShimmer from "components/Shared/ItemShimmer"
import placeholderImage from "assets/images/placeholderImage.png"
import DownloadCSV from "components/Shared/DownloadCSV"
import { pdfDownload } from "helpers/api_helper"
import { EXPORT_DATA } from "helpers/url_helper"
import DownloadXLSX from "components/Shared/DownloadXLSX"
import TableShimmer from "components/Shared/TableShimmer"
import Breadcrumbs from "components/Common/Breadcrumb"
import { getCountryList } from "store/actions/countriesAction"
import { useTranslation } from "react-i18next"

const ModifiersOptions = ({ mode }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Modifiers List | Namq")

  const { categoryId, itemId, modifierOptionId } = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)

  const pageNumber = parseInt(searchParams.get("page")) || 1
  const modifierType = searchParams.get("modifierType")

  const {
    loading,
    modifiers,
    isUpdating,
    isLoading,
    totalPages,
    currentPage,
    itemsPerPage,
    totalCount,
  } = useSelector(state => state.Modifiers)
  const { countryList } = useSelector(state => state.Countries)

  const [selectedId, setSelectedId] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [itemIdToDelete, setItemIdToDelete] = useState(null)
  const [searchTerm, setSearchTerm] = useState(searchParams.get("search") || "")
  const [selectedFilters, setSelectedFilters] = useState({
    status: parseInt(searchParams.get("status") || "2"),
    sortOrder: parseInt(searchParams.get("sortOrder") || "1"),
    countryCode: [],
  })
  const [isApiCalled, setIsApiCalled] = useState(false)
  const [branchId, setBranchId] = useState(null)

  useEffect(() => {
    // Access authUser from localStorage
    const authUser = localStorage.getItem("authUser")

    if (authUser) {
      // Parse the string to an object
      const authUserObj = JSON.parse(authUser)

      // Access the locations array
      const locations = authUserObj.locations

      if (locations && locations.length > 0) {
        setBranchId(locations[0]?._id)
      } else {
        console.error("No locations found in authUser")
      }
    } else {
      // console.error('authUser not found in localStorage');
    }
  }, [])

  const [usersPermissions, setUsersPermissions] = useState({
    list: null,
    create: null,
    edit: null,
    delete: null,
  })

  const { userRole, accountType } = useSelector(state => state.Login)

  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionList = getSubPermissions(
      userRole,
      4,
      "menus_1",
      accountType
    )
    const isPermissionView = isPermissionEnabled(
      userRole,
      4,
      "menus_1",
      accountType
    )
    const isPermissionCreate = isPermissionEnabled(
      userRole,
      4,
      "menus_2",
      accountType
    )
    const isPermissionEdit = getSubPermissions(
      userRole,
      4,
      "menus_3",
      accountType
    )
    const isPermissionDelete = isPermissionEnabled(
      userRole,
      4,
      "menus_4",
      accountType
    )
    if (
      (accountType !== "superadmin" &&
        !isPermissionList?.menu_full_access_view?.isEnabled &&
        !isPermissionList?.modifier_access_view?.isEnabled) ||
      !isPermissionView
    ) {
      navigate("/dashboard")
    } else {
      if (mode === "allModifier") {
        getAllModifierList()
      } else {
        getModifierDetailsFromItem()
      }
    }
    setUsersPermissions({
      list: isPermissionList,
      create: isPermissionCreate,
      edit: isPermissionEdit,
      delete: isPermissionDelete,
    })
  }, [userRole])

  useEffect(() => {
    // if (mode === "allModifier") {
    //   getAllModifierList()
    // } else {
    //   getModifierDetailsFromItem()
    // }
    fetchCountryList()
  }, [mode])

  const getModifierDetailsFromItem = () => {
    const payload = {
      id: modifierOptionId,
    }
    dispatch(getModifierDetails(payload))
    setIsApiCalled(true)
  }

  const fetchCountryList = () => {
    dispatch(getCountryList())
  }

  const filters = [
    {
      name: "status",
      type: "select",
      options: [
        { label: t("All"), value: 2 },
        { label: t("Active"), value: 1 },
        { label: t("Deactive"), value: 0 },
      ],
      placeholder: "All",
    },
    {
      name: "sortOrder",
      type: "select",
      options: [
        { label: t("Ascending"), value: 1 },
        { label: t("Descending"), value: 2 },
      ],
      placeholder: "Ascending",
    },
    {
      name: "countryCode",
      type: "multiSelect",
      options: countryList?.map(item => ({
        label: language === "sa" ? item.nameAr : item.name,
        value: item.countryCode,
      })),

      placeholder: t("Select Countries"),
    },
  ]

  const getAllModifierList = () => {
    const { status, sortOrder } = selectedFilters

    const payload = {
      perPage: 12,
      pageNo: pageNumber,
      status: status,
      orderBy: sortOrder,
      keyword: searchTerm,
    }
    dispatch(getAllModifier(payload))
    setIsApiCalled(true)
  }

  const handleStatusClick = (id, status) => {
    setSelectedId(id)
    const payload = {
      id,
      status: status === 1 ? "0" : "1",
    }
    dispatch(updateModifierStatus(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleOutOfStockForBranch = (id, status) => {
    const payload = {
      id,
      branchId,
      status: !status,
    }
    dispatch(enableDisableModifier(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleDelete = () => {
    const payload = {
      id: itemIdToDelete,
      status: "2", // for delete
    }
    dispatch(deleteModifier(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          setShowDeleteModal(false)
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const getModifiersApiCall = (page = 1) => {
    const { status, sortOrder, countryCode } = selectedFilters
    const updatedCountryCode = countryCode?.map(item => item.value) || []

    const searchParams = new URLSearchParams()
    searchTerm && searchParams.set("search", searchTerm)
    searchParams.set("status", status.toString())
    searchParams.set("sortOrder", sortOrder.toString())
    searchParams.set("page", page.toString())

    const payload = {
      perPage: itemsPerPage,
      pageNo: page,
      status: Number(status), // 0 deactive, 1 active, 2 for all
      orderBy: Number(sortOrder),
      keyword: searchTerm || "",
      countryCode: updatedCountryCode,
    }

    dispatch(getAllModifier(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          navigate(`/menus/modifiers?${searchParams.toString()}`)
        }
      })
      .catch(error => {
        // Handle error if needed
      })
  }

  const handleSearch = () => {
    getModifiersApiCall(1)
  }

  const onPageChange = page => {
    getModifiersApiCall(page)
  }

  // useEffect(() => {
  //   if (isApiCalled) {
  //     const delayDebounceFn = setTimeout(() => {
  //       handleSearch()
  //     }, 500)

  //     return () => clearTimeout(delayDebounceFn)
  //   }
  // }, [searchTerm])

  // useEffect(() => {
  //   if (isApiCalled) {
  //     handleSearch()
  //   }
  // }, [selectedFilters])

  const handleFilterChange = (selectedValue, filterName) => {
    setSelectedFilters(prevFilters => ({
      ...prevFilters,
      [filterName]: selectedValue,
    }))
  }

  const handleSearchChange = e => {
    setSearchTerm(e.target.value)
  }

  const handleReset = () => {
    const payload = {
      perPage: itemsPerPage,
      pageNo: 1,
      status: 2,
      orderBy: 1,
      keyword: "",
    }
    dispatch(getAllModifier(payload))
    setSelectedFilters({
      status: 2,
      sortOrder: 1,
      countryCode: [],
    })
    setSearchTerm("")
    navigate(`/menus/modifiers?page=1`)
    // setItemsPerPage(commonItemPerPage)
  }

  const handleExcelDownload = async () => {
    const { status } = selectedFilters

    const payload = {
      status: Number(status),
      keyword: searchTerm || "",
      type: "MODIFIER",
      exportType: "xlsx",
    }
    const response = await pdfDownload(EXPORT_DATA, payload)
    if (response) {
      const xlsxData = response
      DownloadXLSX(xlsxData, t("Modifiers"))
    }
  }

  const exportToCSV = async () => {
    const { status } = selectedFilters

    const payload = {
      status: Number(status),
      keyword: searchTerm || "",
      type: "MODIFIER",
      exportType: "csv",
    }
    const response = await pdfDownload(EXPORT_DATA, payload)
    if (response) {
      const csvData = response
      DownloadCSV(csvData, t("Modifiers"))
    }
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* <Breadcrumbs /> */}
        <Row>
          <Col xl={12}>
            <Card>
              <DataExportDropdown
                cardTitle={t("Modifiers List")}
                isAddBtn={usersPermissions.create}
                addBtnText={t("Add Modifier Option")}
                onAddBtnClick={() => {
                  if (mode === "allModifier") {
                    navigate("/menus/modifiers/add")
                  } else {
                    modifierType
                      ? navigate(
                          `/menus/categories/${categoryId}/items/${itemId}/modifiers/${modifierOptionId}/items/add?modifierType=${modifierType}`
                        )
                      : navigate(
                          `/menus/categories/${categoryId}/items/${itemId}/modifiers/${modifierOptionId}/items/add`
                        )
                  }
                }}
                isExportData={loading ? false : true}
                onDownloadCSV={exportToCSV}
                onDownloadExcel={handleExcelDownload}
              />
              {/* {!loading && ( */}
              <CardBody>
                {mode === "allModifier" && (
                  <Filters
                    filters={filters}
                    searchTerm={searchTerm}
                    handleSearchChange={handleSearchChange}
                    handleFilterChange={handleFilterChange}
                    handleSearch={handleSearch}
                    onReset={handleReset}
                    selectedFilters={selectedFilters}
                    isCustomPageSize={false}
                    pageSizes={false}
                    searchBy={t("Name")}
                    colSize={4}
                    // itemsPerPage={itemsPerPage}
                    // setItemsPerPage={setItemsPerPage}
                  />
                )}
              </CardBody>
              {/* )} */}
            </Card>
          </Col>
        </Row>
        <Row className="m-auto">
          {loading ? (
            <Card>
              <TableShimmer row={7} col={3} />
            </Card>
          ) : modifiers && modifiers?.length === 0 ? (
            <p className="text-center my-3">{t("No Modifier options found")}</p>
          ) : (
            <Card className="p-0">
              <CardBody className="p-0">
                <Table className="table mb-0 " hover>
                  <thead className="table-light full_th">
                    <tr>
                      <th className="text-start min_80">
                        <span className="d-inline-block py-2 px-2">
                          {t("Modifiers")}
                        </span>
                      </th>
                      {accountType === "superadmin" && (
                        <th className="text-start">
                          <span className="d-inline-block py-2">
                            {t("Status")}
                          </span>
                        </th>
                      )}
                      {usersPermissions?.edit?.enable_out_of_stock_modifier
                        ?.isEnabled &&
                        branchId && (
                          <th className="text-start">
                            <span className="d-inline-block py-2">
                              {t("Mark As Out of Stock")}
                            </span>
                          </th>
                        )}
                      <th className="text-end">
                        <span
                          className="d-inline-block py-2"
                          style={{
                            paddingRight: 20,
                            display: "block",
                          }}
                        >
                          {t("Action")}
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {modifiers?.map(
                      ({
                        _id,
                        name,
                        nameAr,
                        imageUrl,
                        status,
                        outOfStockForBranches,
                        isAllowOutOfStockAction,
                      }) => (
                        <tr key={_id}>
                          <td className="text-start">
                            <div className="left_section ps-2">
                              <Link
                                to={`/menus/modifiers/modifier-details?id=${_id}`}
                              >
                                <div className="d-flex align-items-center">
                                  <img
                                    width={47}
                                    height={44}
                                    src={imageUrl ? imageUrl : placeholderImage}
                                    style={{ objectFit: "contain" }}
                                  />
                                  <h6
                                    className="cat_title in_line_one"
                                    style={{ margin: "0 16px" }}
                                  >
                                    {language === "sa" ? nameAr : name}
                                  </h6>
                                </div>
                              </Link>
                            </div>
                          </td>
                          {accountType === "superadmin" && (
                            <td className="text-start">
                              <div style={{ marginTop: 10 }}>
                                <Switch
                                  isChecked={status}
                                  disabled={_id === selectedId && isUpdating}
                                  onClickHandler={() =>
                                    handleStatusClick(_id, status)
                                  }
                                />
                              </div>
                            </td>
                          )}
                          {/* SHOW OUT OF STOCK FOR BRANCH FOR NON SUPER ADMIN IF HAVE PERMISSION */}
                          {usersPermissions?.edit?.enable_out_of_stock_modifier
                            ?.isEnabled &&
                            branchId && (
                              <td className="text-start">
                                {isAllowOutOfStockAction ? (
                                  <div style={{ marginTop: 10 }}>
                                    <Switch
                                      isChecked={outOfStockForBranches?.includes(
                                        branchId
                                      )}
                                      disabled={
                                        _id === selectedId && isUpdating
                                      }
                                      onClickHandler={() =>
                                        handleOutOfStockForBranch(
                                          _id,
                                          outOfStockForBranches?.includes(
                                            branchId
                                          )
                                        )
                                      }
                                    />
                                  </div>
                                ) : (
                                  "-"
                                )}
                              </td>
                            )}
                          <td className="text-end">
                            <div
                              className="d-flex justify-content-end align-items-center pe-2"
                              style={{ marginTop: 10 }}
                            >
                              {(accountType === "superadmin" ||
                                usersPermissions?.edit?.menu_full_access_update
                                  ?.isEnabled) && (
                                <>
                                  <i
                                    id={`edittooltip_${_id}`}
                                    onClick={() => {
                                      navigate(
                                        mode === "allModifier"
                                          ? `/menus/modifiers/edit?id=${_id}`
                                          : `/menus/categories/${categoryId}/items/${itemId}/modifiers/${modifierOptionId}/items/edit?id=${_id}&modifierType=${modifierType}`
                                      )
                                    }}
                                    className="mdi mdi-pencil font-size-18 text-success mx-2 cursor-pointer"
                                  ></i>
                                  <UncontrolledTooltip
                                    placement="top"
                                    target={`edittooltip_${_id}`}
                                  >
                                    {t("Edit")}
                                  </UncontrolledTooltip>
                                </>
                              )}
                              {usersPermissions.list && (
                                <>
                                  <i
                                    onClick={() => {
                                      navigate(
                                        `/menus/modifiers/modifier-details?id=${_id}`
                                      )
                                    }}
                                    id={`viewtooltip_${_id}`}
                                    className="mdi mdi-eye font-size-18 text-black mx-2 cursor-pointer"
                                  ></i>
                                  <UncontrolledTooltip
                                    placement="top"
                                    target={`viewtooltip_${_id}`}
                                  >
                                    {t("View")}
                                  </UncontrolledTooltip>
                                </>
                              )}
                              {usersPermissions.delete && (
                                <>
                                  <i
                                    id={`deletetooltip_${_id}`}
                                    onClick={e => {
                                      setItemIdToDelete(_id)
                                      setShowDeleteModal(true)
                                    }}
                                    className="bx bxs-trash font-size-18 mx-2 cursor-pointer"
                                    style={{ color: "#FD5F62" }}
                                  ></i>
                                  <UncontrolledTooltip
                                    placement="top"
                                    target={`deletetooltip_${_id}`}
                                  >
                                    {t("Delete")}
                                  </UncontrolledTooltip>
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          )}

          {modifiers?.length > 0 && !loading && mode === "allModifier" && (
            <Card>
              <CardBody>
                <Paginations
                  data={modifiers}
                  itemsPerPage={itemsPerPage}
                  onPageChange={onPageChange}
                  currentPage={currentPage}
                  totalPages={totalPages}
                  totalCount={totalCount}
                />
              </CardBody>
            </Card>
          )}
        </Row>
      </div>
      <DeleteModal
        show={showDeleteModal}
        onDeleteClick={handleDelete}
        isLoading={isLoading}
        onCloseClick={() => {
          setItemIdToDelete(null)
          setShowDeleteModal(false)
        }}
        buttonText={t("Delete")}
        bodyTitle={t("Are you sure you want to delete this {{name}}?", {
          name: t("Modifier"),
        })}
      />
    </div>
  )
}

export default ModifiersOptions
